module.exports = __webpack_public_path__ + "img/favorite-item.88d793bf.png";